import axios from '@/lib/AxApi';

export default {
    async selectRowById(params)
    {
        try
        {
            const response = await axios.get('/Users/selectRowById', {
                params,
            });
            return response.data;
        }
        catch (e)
        {
            throw ({
                error: true,
                notice: axios.errorHandler(e),
            });
        }
    },
    async selectRow(params)
    {
        try
        {
            const response = await axios.get('/Users/selectRow', {
                params,
            });
            return response.data;
        }
        catch (e)
        {
            throw ({
                error: true,
                notice: axios.errorHandler(e),
            });
        }
    },
    async save(params)
    {
        try
        {
            let func = 'insertRow';
            if (typeof params.id !== 'undefined' && params.id !== '')
            {
                func = 'updateRow';
            }

            const response = await axios.post(`/Users/${func}`, params);
            return response.data;
        }
        catch (e)
        {
            throw ({
                error: true,
                notice: axios.errorHandler(e),
            });
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/Users/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({
                error: true,
                notice: axios.errorHandler(e),
            });
        }
    },
    async changePassword(params)
    {
        try
        {
            const response = await axios.post('/Users/changePassword', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
};
